import script from "./MallStorePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallStorePage.vue?vue&type=script&setup=true&lang=ts"

import "./MallStorePage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__